import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, ServerIcon, PaletteIcon, SmartphoneIcon, MessageCircleIcon, ClockIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const benefits = [{
  icon: GlobeIcon,
  title: 'Dominio propio',
  text: 'Tu marca con su propia dirección: tunegocio.com, lista y configurada.'
}, {
  icon: ServerIcon,
  title: 'Hosting incluido',
  text: 'Servidor rápido y seguro incluido, sin configuraciones técnicas de tu parte.'
}, {
  icon: PaletteIcon,
  title: 'Diseño personalizado',
  text: 'Colores, fotos y textos pensados para tu rubro, no una plantilla genérica.'
}, {
  icon: SmartphoneIcon,
  title: 'Adaptada a celulares',
  text: 'Se ve perfecta en móvil, tablet y escritorio. Ahí están tus clientes.'
}, {
  icon: MessageCircleIcon,
  title: 'WhatsApp integrado',
  text: 'Botón directo a tu WhatsApp para que te escriban en un solo toque.'
}, {
  icon: ClockIcon,
  title: 'Entrega en 24 horas',
  text: 'Nos mandás la info hoy y mañana tu web ya está online vendiendo.'
}];
export function Benefits() {
  return <section id="beneficios" className="w-full bg-white py-20 sm:py-28" data-id="element-13" data-mp="3oyea0j5kt67a">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-14" data-mp="3p08ujwcxqwau">
        <SectionHeading eyebrow="Beneficios" title="Todo lo que necesitás, ya incluido" description="Sin sorpresas ni costos ocultos: entregamos una web completa y lista para trabajar." data-id="element-15" data-mp="3tyk569b21au4" />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-16" data-mp="qg8wtimx2ak0">
          {benefits.map((benefit, index) => <motion.article key={benefit.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.05,
          ease: [0.22, 1, 0.36, 1]
        }} className="group rounded-3xl border border-black/5 bg-white p-7 shadow-soft transition-all hover:-translate-y-1 hover:shadow-lift" data-id="element-17" data-mp="bq1qu2e3ik07" data-mpi={index}>
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-yellow" data-id="element-18" data-mp="1e4p2eqfmewks">
                <benefit.icon className="h-6 w-6 text-brand-ink" aria-hidden="true" data-id="element-19" data-mp="193hv0she3zen" />
              </span>
              <h3 className="mt-5 text-lg font-bold" data-id="element-20" data-mp="1537pti1f9d0u">{benefit.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-ink/60" data-id="element-21" data-mp="105fvyih7vgu0">{benefit.text}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}